import React from "react";
import "./PageFooter.css";
import useLang from "../../i18n/useLang";
import { demoUrl, siteUrl } from "../../i18n/links";

const CONTENT = {
  fr: {
    title: "Prêt à développer votre visibilité locale ?",
    subtitle:
      "Franchises, réseaux multi-établissements, agences, Localranker vous accompagne à grande échelle.",
    cta: "Demander une démo",
    copyright: "Localranker — Logiciel de visibilité locale intelligent",
  },
  en: {
    title: "Ready to grow your local visibility?",
    subtitle:
      "Franchises, multi-location brands and agencies: Localranker helps you manage local SEO at scale.",
    cta: "Book a demo",
    copyright: "Localranker — Local SEO software for multi-location brands",
  },
};

const PageFooter = () => {
  const lang = useLang();
  const t = CONTENT[lang];

  return (
    <>
      <section className="cta-section">
        <div className="cta-section__radar" aria-hidden="true">
          <div className="cta-orbit cta-orbit--1">
            <span />
          </div>
          <div className="cta-orbit cta-orbit--2">
            <span />
          </div>
        </div>
        <div className="cta-section__inner">
          <h2 className="cta-section__title">{t.title}</h2>
          <p className="cta-section__subtitle">{t.subtitle}</p>
          <a
            className="cta-section__btn"
            href={demoUrl(lang, "footer")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t.cta}
          </a>
        </div>
      </section>

      <footer className="site-footer">
        <div className="site-footer__inner">
          <span className="site-footer__text">
            © {new Date().getFullYear()} {t.copyright}
          </span>
          <a
            className="site-footer__link"
            href={siteUrl(lang)}
            target="_blank"
            rel="noopener noreferrer"
          >
            localranker.fr
          </a>
        </div>
      </footer>
    </>
  );
};

export default PageFooter;
